export default "__VITE_ASSET__BsGwsjLN__"